module.exports = __webpack_public_path__ + "static/img/sebastian_logo_layer_at_1440x1105.15fcf63.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_logo_layer_at_1440x1105.png
// module id = wW9Q
// module chunks = 0